export type IJurisdictionDocumentTypeRelation = {
  jurisdictionId: number;
  documentTypeId: number;
};

export const JurisdictionDocumentTypeDataUtil = {
  generateEntityKey: (args: Pick<IJurisdictionDocumentTypeRelation, "jurisdictionId" | "documentTypeId">) =>
    `jurisdictionId:${args.jurisdictionId}|documentTypeId:${args.documentTypeId}`,
};
